export default "__VITE_ASSET__BvRlkPOg__"